import { Editor } from 'slate';
import { insertLeafDirective } from '../directive/transforms';

export function insertAudio(editor: Editor, url: string) {
    insertLeafDirective(editor, { name: 'audio', attributes: { src: url, controls: 'controls' } });
}
